
import SelectAbstract from "components/SelectAbstract";
import ButtonIcon from "components/ButtonIcon";

import './index.less';
import './themes/default.less';

export default class ButtonIconSelect extends SelectAbstract {
    getMainStyle() {
        return "buttonSelect";
    }

    onItemSelect({ onClick }, e) {
        if (this.props.stopEvent)
            this._helper.stopEvent(e);

        if (onClick?.apply)
            onClick();
    }

    selfToggle(e) {
        if (this.props.stopEvent)
            this._helper.stopEvent(e);

        this.toggleOpenedState();

        if (this.props.onClick?.apply)
            this.props.onClick();
    }

    renderSelector() {
        const { items, onClick, } = this.props;

        return (
            <div ref={el => this.selector = el}>
                <ButtonIcon
                    {...this.props}
                    onClick={items ? this.selfToggle.bind(this) : onClick}
                />
            </div>
        );
    }
}
